import { CmtsMasterDataCrudShell } from "../components/master-data/index.js";

export function CmtsReferenceDataPage() {
  return <CmtsMasterDataCrudShell entityKey="reference-data" />;
}

export default CmtsReferenceDataPage;
